export default __webpack_public_path__ + "static/appscreenshots_1-c27a9e9154d6744731de4d18a0360999.png";